import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';
import { PrefetchLinkDirective, TooltipDirective } from '@kaseya-design-components';
import { NavigationFacade } from '@core/navigation/facades/navigation.facade';
import { TopNavigationPath } from '@core/navigation/models/top-navigation/top-navigation-path';
import { asNonUndefined } from '@kaseya-utils';

@Component({
  selector: 'itc-navigation-link',
  templateUrl: 'navigation-link.component.html',
  styleUrl: 'navigation-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [RouterLinkActive, TooltipDirective, RouterLink, PrefetchLinkDirective, NgTemplateOutlet],
})
export class NavigationLinkComponent {
  private readonly navigationFacade = inject(NavigationFacade);

  readonly linkName = input.required<string>();
  readonly iconClass = input<string>();
  readonly id = input<string>();
  readonly isTooltipEnabled = input(false);
  readonly showIcon = input(true);
  readonly topNavigation = input<TopNavigationPath>();
  readonly routerLink = computed(() => this.navigationFacade.getRouterLinkById(this.id(), this.topNavigation()));

  setNavigationItemIfActive(isActive: boolean): void {
    if (isActive && this.id() && this.id() !== this.navigationFacade.activeLeftNavigation()) {
      this.navigationFacade.setActiveLeftNavigation(asNonUndefined(this.id()));
    }

    if (isActive && this.topNavigation() && this.topNavigation() !== this.navigationFacade.activeTopNavigation()) {
      this.navigationFacade.setActiveTopNavigation(asNonUndefined(this.topNavigation()));
    }
  }
}
